import { styled } from 'styled-components'
import { IoIosCheckmarkCircle } from 'react-icons/io'

const Img = styled.img`
    width: 70%;
    position: relative;
    vertical-align: top;
`
const Wrapper = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    align-items: flex-start;
`

const ContentWrapper = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    width: 50%;
    gap: 20px;
`
const NextButton = styled.button`
    width: 120px;
    height: 40px;
    background-color: #31c690;
    color: white;
    border: none;
    border-radius: 50px;
    font-size: 16px;
    &:hover {
        cursor: pointer;
        background-color: #28a57a;
    }
`

const GreenTick = styled(IoIosCheckmarkCircle)`
    color: #31c690;
    width: 18px;
    height: 18px;
`

const ItemWrapper = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
`

const PicWrapper = styled.div`
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    vertical-align: top;
`

export default function Equipment({
    handleNextButtonClick,
}: {
    handleNextButtonClick: (componentName: 'AssessmentSetup') => void
}) {
    return (
        <Wrapper>
            <PicWrapper>
                <Img src="/images/home/equipment.png" />
            </PicWrapper>
            <ContentWrapper>
                <h1>Equipment</h1>
                <ItemWrapper>
                    <GreenTick />
                    <label>Poly dot, tape or cones</label>
                </ItemWrapper>
                <ItemWrapper>
                    <GreenTick />{' '}
                    <label>2 x foam soccer balls (20.3 - 25.4cms)</label>
                </ItemWrapper>
                <ItemWrapper>
                    <GreenTick />
                    <label> 2 x foam tennis ball sized ball </label>
                </ItemWrapper>
                <ItemWrapper>
                    <GreenTick />
                    <label> 2 x 10.2 cm plastic/foam ball </label>
                </ItemWrapper>
                <ItemWrapper>
                    <GreenTick />
                    <label> Video equipment / Device </label>
                </ItemWrapper>
                <ItemWrapper>
                    <GreenTick />
                    <label> Tripod or table </label>
                </ItemWrapper>
                <ItemWrapper>
                    <GreenTick />
                    <label> Charging cords </label>
                </ItemWrapper>
                <NextButton
                    onClick={() => handleNextButtonClick('AssessmentSetup')}
                >
                    Next
                </NextButton>
            </ContentWrapper>
        </Wrapper>
    )
}
